module.exports = __webpack_public_path__ + "media/images/download_icon-7056a977.png";